// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.swap-description[data-v-336cede6] {\n  display: block;\n  width: 400px;\n  font-weight: 600;\n  font-size: 1.8rem;\n  line-height: 1.4;\n}\n.abort-btn[data-v-336cede6] {\n  background-color: rgb(var(--status-aborted));\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
